import { render, staticRenderFns } from "./MessageMentionEntityRegexpTypeSetupView.vue?vue&type=template&id=2e3a7676&scoped=true&"
import script from "./MessageMentionEntityRegexpTypeSetupView.vue?vue&type=script&lang=ts&"
export * from "./MessageMentionEntityRegexpTypeSetupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3a7676",
  null
  
)

export default component.exports